import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    // Get the API base URL based on environment
    const getApiBaseUrl = () => {
        if (process.env.NODE_ENV === 'production') {
            return 'https://onedeadbird.com';
        } else {
            return 'http://localhost:6969';
        }
    };

    const checkAuthStatus = async () => {
        try {
            console.log('Checking authentication with:', `${getApiBaseUrl()}/api/auth/status`);
            
            // Use the same auth endpoint as other games
            const response = await fetch(`${getApiBaseUrl()}/api/auth/status`, {
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Auth status response:', data);
                
                if (data?.success && data?.isAuthenticated && data?.user) {
                    setUser(data.user);
                    setIsAdmin(data.user.isAdmin || false);
                    console.log('User authenticated:', data.user);
                } else {
                    console.log('User not authenticated');
                    setUser(null);
                    setIsAdmin(false);
                }
            } else {
                console.log('Auth check failed with status:', response.status);
                setUser(null);
                setIsAdmin(false);
            }
        } catch (error) {
            console.log('Auth check failed:', error);
            setUser(null);
            setIsAdmin(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuthStatus();
    }, []);

    // Login and logout functions
    const login = () => {
        const loginUrl = `${getApiBaseUrl()}/login?ref=${encodeURIComponent(window.location.href)}`;
        window.location.href = loginUrl;
    };

    const logout = () => {
        const logoutUrl = `${getApiBaseUrl()}/users/logout?ref=${encodeURIComponent(window.location.href)}`;
        window.location.href = logoutUrl;
    };

    const value = {
        user,
        isAdmin,
        loading,
        apiBaseUrl: getApiBaseUrl(),
        refreshAuth: checkAuthStatus,
        login,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
